export default "__VITE_ASSET__BIyfos1S__"